import React from 'react';
import { Skeleton } from 'antd';
import './ObjectCardSkeleton.css';

export const ObjectCardSkeleton: React.FC = () => (
  <div className="object-card-skeleton" aria-hidden>
    <div className="object-card-skeleton__top">
      <Skeleton.Avatar active size={60} shape="square" style={{ borderRadius: 12 }} />
      <div className="object-card-skeleton__top-actions">
        <Skeleton.Button active size="small" style={{ width: 36, height: 36, borderRadius: 10 }} />
        <Skeleton.Button active size="small" style={{ width: 36, height: 36, borderRadius: 10 }} />
      </div>
    </div>
    <div>
      <Skeleton.Input active size="large" style={{ width: '60%', height: 24, borderRadius: 6, marginBottom: 8 }} />
      <div className="object-card-skeleton__bottom-stats">
        <Skeleton.Input active size="small" style={{ width: 40, height: 16, borderRadius: 4 }} />
        <Skeleton.Input active size="small" style={{ width: 40, height: 16, borderRadius: 4 }} />
      </div>
    </div>
  </div>
);
